import FieldMixins from './mixins/field_mixin.js';

export default Vue.extend({
  mixins: [FieldMixins],

  template: `
    <FieldView :editing='editing'
               :field='field'
               :field_groups='field_groups'
               :layouts='availableLayouts'
               :disabledFieldLayout='disabledFieldLayout'
               ref='fieldView'>
      <template slot='content'>
        <div :class="(editing ? 'edit' : 'display') + '-content'">
          <button class="btn-default" readonly>
            <span>选择文件</span>
            <i class="slp-upload-o"></i>
          </button>
        </div>
      </template>
      <div class="list-group" slot="common-settings">
        <div class="list-group-name">填写设置</div>
        <div class="list-item clickable"
              @click="toggleSetting('location_watermark')">
          <div class="tip">
            <i :class='[ field.settings.location_watermark ? "slp-check" : "slp-empty" ]'></i>
          </div>
          <div class="content force-no-wrap slp-tooltip bottom">
            <span>{{_getFillSettingTitle('location_watermark')}}</span>
            <div class="slp-tooltip-content">{{ _getFillSettingTip('location_watermark') }}</div>
            <i class="slp-question-circle"></i>
          </div>
        </div>
        <div class="list-item clickable"
              @click="toggleSetting('datetime_watermark')">
          <div class="tip">
            <i :class='[ field.settings.datetime_watermark ? "slp-check" : "slp-empty" ]'></i>
          </div>
          <div class="content force-no-wrap slp-tooltip bottom">
            <span>{{_getFillSettingTitle('datetime_watermark')}}</span>
            <div class="slp-tooltip-content">{{ _getFillSettingTip('datetime_watermark') }}</div>
            <i class="slp-question-circle"></i>
          </div>
        </div>
      </div>
    </FieldView>
  `,

  methods: {
    toggleSetting(key) {
      if (!this.field.settings.hasOwnProperty(key)) Vue.set(this.field.settings, key, null);
      this.field.settings[key] = !this.field.settings[key];
    },

    _getFillSettingTitle(fillSetting) {
      return Skylark.Helpers.translate(`field.fillSetting.${fillSetting}.title`);
    },

    _getFillSettingTip(fillSetting) {
      return Skylark.Helpers.translate(`field.fillSetting.${fillSetting}.tip`);
    },
  },
});
